<template>
  <CRow>
    <CCol sm="6" lg="3">
      <CWidgetDropdown color="primary" header="9.823 USD" text="可用余额">
        <template #default>
          <CDropdown
            color="transparent p-0"
            placement="bottom-end"
          >
            <template #toggler-content>
              <CIcon name="cil-settings"/>
            </template>
            <CDropdownItem>充值</CDropdownItem>
            <CDropdownItem>提现</CDropdownItem>
            <CDropdownItem>转账</CDropdownItem>
            <!-- <CDropdownItem disabled>Disabled action</CDropdownItem> -->
          </CDropdown>
        </template>
        <template #footer>
          <CCol class="mt-3 mx-3 co" style="">
            <CButton block variant="outline" color="light">账户流水</CButton>
          </CCol>
          <!-- <CChartLineSimple
            pointed
            class="mt-3 mx-3"
            style="height:70px"
            :data-points="[65, 59, 84, 84, 51, 55, 40]"
            point-hover-background-color="primary"
            label="Members"
            labels="months"
          /> -->
        </template>
      </CWidgetDropdown>
    </CCol>
    <CCol sm="6" lg="3">
      <CWidgetDropdown color="info" header="1000" text="激活卡量">
        <template #default>
          <CDropdown
            color="transparent p-0"
            placement="bottom-end"
            :caret="false"
          >
            <template #toggler-content>
              <CIcon name="cil-location-pin"/>
            </template>
            <CDropdownItem>充值</CDropdownItem>
            <CDropdownItem>提现</CDropdownItem>
            <CDropdownItem>转账</CDropdownItem>
            <!-- <CDropdownItem disabled>Disabled action</CDropdownItem> -->
          </CDropdown>
        </template>
        <template #footer>
          <CCol class="mt-3 mx-3 co" style="">
            <CButton block variant="outline" color="light">卡管理</CButton>
          </CCol>
          <!-- <CChartLineSimple
            pointed
            class="mt-3 mx-3"
            style="height:70px"
            :data-points="[1, 18, 9, 17, 34, 22, 11]"
            point-hover-background-color="info"
            :options="{ elements: { line: { tension: 0.00001 }}}"
            label="Members"
            labels="months"
          /> -->
        </template>
      </CWidgetDropdown>
    </CCol>
    <CCol sm="6" lg="3">
      <CWidgetDropdown
        color="warning"
        header="9.823"
        text="消费总额"
      >
        <template #default>
          <CDropdown
            color="transparent p-0"
            placement="bottom-end"
          >
            <template #toggler-content>
              <CIcon name="cil-settings"/>
            </template>
            <CDropdownItem>充值</CDropdownItem>
            <CDropdownItem>提现</CDropdownItem>
            <CDropdownItem>转账</CDropdownItem>
            <!-- <CDropdownItem disabled>Disabled action</CDropdownItem> -->
          </CDropdown>
        </template>
        <template #footer>
          <CCol class="mt-3 mx-3 co" style="">
            <CButton block variant="outline" color="light">消费明细</CButton>
          </CCol>
          <!-- <CChartLineSimple
            class="mt-3"
            style="height:70px"
            background-color="rgba(255,255,255,.2)"
            :data-points="[78, 81, 80, 45, 34, 12, 40]"
            :options="{ elements: { line: { borderWidth: 2.5 }}}"
            point-hover-background-color="warning"
            label="Members"
            labels="months"
          /> -->
        </template>
      </CWidgetDropdown>
    </CCol>
    <CCol sm="6" lg="3">
      <CWidgetDropdown
        color="danger"
        header="9.823"
        text="拒付率"
      >
        <template #default>
          <CDropdown
            color="transparent p-0"
            placement="bottom-end"
          >
            <template #toggler-content>
             <CIcon name="cil-settings"/>
            </template>
            <CDropdownItem>充值</CDropdownItem>
            <CDropdownItem>提现</CDropdownItem>
            <CDropdownItem>转账</CDropdownItem>
            <!-- <CDropdownItem disabled>Disabled action</CDropdownItem> -->
          </CDropdown>
        </template>
        <template #footer>
          <CCol class="mt-3 mx-3 co" style="">
            <CButton block variant="outline" color="light">拒付明细</CButton>
          </CCol>
          <!-- <CChartBarSimple
            class="mt-3 mx-3"
            style="height:70px"
            background-color="rgb(250, 152, 152)"
            label="Members"
            labels="months"
          /> -->
        </template>
      </CWidgetDropdown>
    </CCol>
  </CRow>
</template>

<script>
import { CChartLineSimple, CChartBarSimple } from '../charts/index.js'

export default {
  name: 'WidgetsDropdown',
  components: { CChartLineSimple, CChartBarSimple }
}
</script>
<style scoped>
  .co{
    height:70px;
    margin-left:0 !important;
    margin-bottom:1.5rem !important;
    margin-top:1.5rem !important
  }
</style>
